var _Path, _Path2, _Circle, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";
var SvgFlashCheck = function SvgFlashCheck(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 124,
    height: 70,
    viewBox: "0 0 124 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.93 8.557A34.865 34.865 0 0 0 35 0C15.67 0 0 15.67 0 35s15.67 35 35 35a34.865 34.865 0 0 0 22.934-8.56 39.519 39.519 0 0 1-10.1-26.444A39.52 39.52 0 0 1 57.93 8.557Z",
    fill: "#4285F4"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.073 11.666 20.518 38.89h11.666l-3.889 19.444 15.556-27.222H32.184l3.89-19.445Z",
    fill: "white"
  })), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 88.998,
    cy: 35,
    r: 35,
    fill: "#37CC33"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "m76.498 35 10.417 10.417L101.498 22.5",
    stroke: "white",
    strokeWidth: 4.26,
    strokeLinecap: "round"
  })));
};
export default SvgFlashCheck;